import { Preview } from "components/PreviewModal";
import { useModal } from "hooks/useModal";
import { FileIcon } from "components/design/FileIcon";

export const TaskRelatedFile = ({
  fileId,
  fileType,
  groupId,
}: {
  fileId: string;
  fileType: string;
  groupId: string;
}) => {
  const { open, close, isOpen } = useModal();

  return (
    <>
      <button className="all:unset" onClick={open}>
        <FileIcon fileType={fileType} size="24" />
      </button>
      {isOpen && (
        <Preview
          showModal={isOpen}
          closeModal={close}
          previewId={fileId}
          groupId={groupId}
        />
      )}
    </>
  );
};
